import script from "./PropertyCardSubLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCardSubLocation.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCardSubLocation.vue?vue&type=style&index=0&id=4ad89c50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad89c50"]])

export default __exports__